import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { quoteService } from '../services/quoteService';
import { toast } from 'react-hot-toast';

export const useQuotes = () => {
    const queryClient = useQueryClient();

    const { data, isLoading, error } = useQuery({
        queryKey: ['availableQuotes'],
        queryFn: () => quoteService.getAvailableRequests().then(res => res.data.data),
        staleTime: 1000 * 60,
        cacheTime: 1000 * 60 * 5,
    });

    const useQuoteDetails = (quoteId) => {
        return useQuery({
            queryKey: ['quote', quoteId],
            queryFn: () => quoteService.getQuoteById(quoteId).then(res => res.data.data),
            enabled: !!quoteId,
            staleTime: 1000 * 30,
        });
    };

    const createOfferMutation = useMutation({
        mutationFn: ({ quoteId, data }) => quoteService.createOffer(quoteId, data),
        onSuccess: () => {
            toast.success('Offer sent successfully!');
            queryClient.invalidateQueries({ queryKey: ['availableQuotes'] });
        },
        onError: (err) => {
            toast.error(err.response?.data?.message || 'Failed to send offer');
        },
    });

    return {
        quotes: data || [],
        isLoading,
        error,
        useQuoteDetails,
        createOffer: createOfferMutation.mutate,
        isCreatingOffer: createOfferMutation.isPending,
    };
};